import type { FC, SVGProps } from 'react'

export const IDCard: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.9224 14.4243H24.9224"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9224 18.4243H24.9224"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4351 18.4243C14.0919 18.4243 15.4351 17.0812 15.4351 15.4243C15.4351 13.7675 14.0919 12.4243 12.4351 12.4243C10.7782 12.4243 9.43506 13.7675 9.43506 15.4243C9.43506 17.0812 10.7782 18.4243 12.4351 18.4243Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.56006 21.4243C8.78036 20.5639 9.28076 19.8013 9.98237 19.2567C10.684 18.7121 11.5469 18.4165 12.4351 18.4165C13.3232 18.4165 14.1861 18.7121 14.8877 19.2567C15.5894 19.8013 16.0898 20.5639 16.3101 21.4243"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.9224 6.42432H5.92236C5.37008 6.42432 4.92236 6.87203 4.92236 7.42432V25.4243C4.92236 25.9766 5.37008 26.4243 5.92236 26.4243H27.9224C28.4746 26.4243 28.9224 25.9766 28.9224 25.4243V7.42432C28.9224 6.87203 28.4746 6.42432 27.9224 6.42432Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
